import { KEY } from '../../types';
import * as types from './types';

export const GET_PROVIDERS_FOR_PRACTICE = `${KEY}.GET_PROVIDERS_FOR_PRACTICE`;
export const GET_PROVIDERS_FOR_PRACTICE_SUCCESS = `${KEY}.GET_PROVIDERS_FOR_PRACTICE_SUCCESS`;
export const GET_PROVIDERS_FOR_PRACTICE_FAIL = `${KEY}.GET_PROVIDERS_FOR_PRACTICE_FAIL`;

export const getProvidersForPractice = (payload: types.GetProvidersForPracticePayload) => ({
  type: GET_PROVIDERS_FOR_PRACTICE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'providers',
      data: payload
    }
  }
});

export const GET_PROVIDER_DETAIL = `${KEY}.GET_PROVIDER_DETAIL`;
export const GET_PROVIDER_DETAIL_SUCCESS = `${KEY}.GET_PROVIDER_DETAIL_SUCCESS`;
export const GET_PROVIDER_DETAIL_FAIL = `${KEY}.GET_PROVIDER_DETAIL_FAIL`;

export const getProviderDetail = (payload: types.GetProviderDetailPayload) => ({
  type: GET_PROVIDER_DETAIL,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'providerDetail',
      data: payload
    }
  }
});

export const GET_ESTIMATED_VISIT_COST = `${KEY}.GET_ESTIMATED_VISIT_COST`;
export const GET_ESTIMATED_VISIT_COST_SUCCESS = `${KEY}.GET_ESTIMATED_VISIT_COST_SUCCESS`;
export const GET_ESTIMATED_VISIT_COST_FAIL = `${KEY}.GET_ESTIMATED_VISIT_COST_FAIL`;

export const getEstimatedVisitCost = (payload: types.GetProviderDetailPayload) => ({
  type: GET_ESTIMATED_VISIT_COST,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'estimatedVisitCost',
      data: payload
    }
  }
});

export const SET_PROVIDER_DETAILS_WERE_VIEWED = `${KEY}.SET_PROVIDER_DETAILS_WERE_VIEWED`;

export const setProviderDetailsWereViewed = (providerDetailsWereViewed: boolean) => ({
  type: SET_PROVIDER_DETAILS_WERE_VIEWED,
  payload: providerDetailsWereViewed
});
